import { Button } from "../ui/button";
import { useDensity } from "../ui/density";
import { Icon } from "../ui/icon";
import { Tooltip } from "../ui/tooltip";

/** Comfortable (44 px targets) or compact (36 px rows, 32 px targets). A pressed button means compact. See ADR 0016. */
export function DensityToggle() {
  const { density, setDensity } = useDensity();
  const compact = density === "compact";
  return (
    <Tooltip content={compact ? "Compact density is on" : "Compact density is off"}>
      <Button
        variant="ghost"
        size="icon"
        aria-pressed={compact}
        aria-label="Compact density"
        onClick={() => setDensity(compact ? "comfortable" : "compact")}
      >
        <Icon name={compact ? "menu-02" : "menu-01"} size="lg" />
      </Button>
    </Tooltip>
  );
}
